import { render } from "./RadialbarCharts.vue?vue&type=template&id=2a5a791f"
import script from "./RadialbarCharts.vue?vue&type=script&lang=js"
export * from "./RadialbarCharts.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__